export const TemplateTypes = [
  {
    label: "스케줄",
    value: "schedule",
  },
  {
    label: "불판",
    value: "thread",
  },
  {
    label: "공지사항",
    value: "notice",
  },
];
